<div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 car-overview">
  <!-- <div class="item text-center">
    <img class="tw-inline" src="../../../../../assets/images/car/abs.svg" alt="" srcset="">
    <p class="label">Engine</p>
    <p class="value">{{carDetails?.variant?.specifications?.displacement}} cc</p>
  </div> -->
  <div class="item text-center">
    <img class="tw-inline" src="../../../../../assets/images/car/transmission.svg" alt="" srcset="">
    <p class="label">Transmission</p>
    <p class="value">{{carDetails?.variant?.specifications?.transmissionType}}</p>
  </div>
  <div class="item text-center">
    <img class="tw-inline" src="../../../../../assets/images/car/fuel.svg" alt="" srcset="">
    <p class="label">Fuel Type</p>
    <p class="value">{{carDetails?.variant?.specifications?.fuelType}}</p>
  </div>
  <div class="item text-center">
    <img class="tw-inline" src="../../../../../assets/images/car/airbags.svg" alt="" srcset="">
    <p class="label">Seating Capacity</p>
    <p class="value">{{carDetails?.variant?.specifications?.seatingCapacity}} Seater</p>
  </div>
  <!-- <div class="item text-center">
    <img class="tw-inline" src="../../../../../assets/images/car/mileage.svg" alt="" srcset="">
    <p class="label">Mileage</p>
    <p class="value">{{carDetails?.variant?.specifications?.bodyType}}</p>
  </div> -->
  <div class="item text-center">
    <img class="tw-inline" src="../../../../../assets/images/car/body-type.svg" alt="" srcset="">
    <p class="label">Car Type</p>
    <p class="value">{{carDetails?.variant?.specifications?.bodyType}}</p>
  </div>
</div>